import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.form = document.getElementById(this.element.dataset.formId)
    this.selectedUserIds = this.form
      ? [...this.form.querySelectorAll('input[name="live_stream[user_ids][]"]')]
          .map(i => i.value.trim())
          .filter(Boolean)
      : [];

    const token = document.querySelector('meta[name="csrf-token"]').content;
    fetch('/user_selections/all_selected_users', {
      method: 'POST',
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({
        user_ids: this.selectedUserIds
      })
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html));

    const checkboxes = this.element.querySelectorAll('input[type="checkbox"][data-user-id]')
    checkboxes.forEach(checkbox => {
      if (this.selectedUserIds.includes(checkbox.dataset.userId)) {
        checkbox.checked = true
      }
    })
    $('.target_people_error').addClass('d-none')
  }

  searchInput() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      this.submitSearch()
    }, 400)
  }

  submitSearch() {
    const form = this.element.querySelector("#user-search-form")
    if (!form) return

    form.querySelectorAll('input[name="selected_ids[]"]').forEach(i => i.remove())
    this.selectedUserIds.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "selected_ids[]"
      input.value = id
      form.appendChild(input)
    })

    form.requestSubmit()
  }

  toggle(e) {
    $('.target_user_error').addClass('d-none');
    const id = e.target.value
    if (e.target.checked) {
      if (!this.selectedUserIds.includes(id)) {
        this.selectedUserIds.push(id)
        fetch(`/user_selections/${id}/select`, {
          headers: {
            "Accept": "text/vnd.turbo-stream.html"
          }
        })
          .then(response => response.text())
          .then(html => {
            Turbo.renderStreamMessage(html)
          })
      }
    } else {
      this.removeSelectedUser(id)
    }
    console.log('toggle--> this.selectedUserIds-->. ', this.selectedUserIds)
  }

  removeSelectedUser(id) {
    this.selectedUserIds = this.selectedUserIds.filter(i => i !== id)
    const el = document.getElementById(`selected-user-${id}`)
    if (el) el.remove()
  }

  removeFromTop(event) {
    const id = event.target.dataset.id
    this.removeSelectedUser(id)
    const checkbox = this.element.querySelector(`input[type="checkbox"][value="${id}"]`)
    if (checkbox) checkbox.checked = false
  }

  confirm() {
    const errorDiv = $('.target_user_error');
    if (this.selectedUserIds.length > 0) {
      errorDiv.addClass('d-none');
      const token = document.querySelector('meta[name="csrf-token"]').content;
      fetch('/user_selections/selected_users', {
        method: 'POST',
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "Content-Type": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({
          user_ids: this.selectedUserIds
        })
      })
        .then(r => r.text())
        .then(html => Turbo.renderStreamMessage(html));
          this.close()
    } else {
      errorDiv.removeClass('d-none');
    }
  }

  applyFilter(e) {
    let filterValue = e.currentTarget.value;
    const params = new URLSearchParams();

    this.selectedUserIds.forEach(id => {
      params.append("selected_ids[]", id);
    });

    if (filterValue !== "all") {
      params.append("filter", filterValue);
    }
    fetch('/user_selections?' + params.toString(), {
      method: 'GET',
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/json"
      }
    }).then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html));
  }

  close() {
    bootstrap.Modal.getInstance(this.element.closest('.modal')).hide()
  }
}
